<template>
  <b-row>
    <b-col lg="3" xl="2" xxl="2" class="leftsidebar">
      <LeftBar
        masterheading="GRN Return"
        @clickdata="ItemShow()"
        v-model="Id"
        :storestatus="false"
        :listed="sidebardata"
      ></LeftBar>
      <a class="back-btn" @click="router.back">
        <img
          alt="Vue logo"
          class="back"
          src="../../../../../../assets/Img/icons/backtoright.svg"
          width="125"
          height="125"
        />
      </a>
    </b-col>
    <b-col lg="9" xl="10" xxl="10" class="overall-bg">
      <div class="common-heading1 mt-5 mb-5">Medway Pharmacy</div>
      <Tableview
        :value="ItemList"
        :paginator="true"
        class="p-datatable-gridlines"
        :rows="10"
        :rowHover="true"
        filterDisplay="menu"
        :loading="loading"
        responsiveLayout="scroll"
        :columns="headers"
        @row-click=""
        :globalFilterFields="globalFilterFields"
        :filters="filters"
        selectionMode="single"
      >
        <template v-slot:Add>
          <span> </span>
        </template>
        <template v-slot:action="{ data }">
          <span> </span>
        </template>
      </Tableview>
    </b-col>
  </b-row>
</template>
<script lang="ts">
import { defineComponent, ref, Ref, onMounted, watch } from "vue";
import LeftBar from "../../../../../../modules/Inventory/components/MasterDetails/LeftSideBar.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import Tableview from "../../../../../../components/FormComponents/Table.vue";
import { useI18n } from "vue-i18n";
import Service from "../../../../Service/WithoutStockAffectService";
import StockoutService from "../../../../../../modules/Inventory/Service/StockOutService";
import { useRoute, useRouter } from "vue-router";

export default defineComponent({
  components: {
    LeftBar,
    Tableview,
  },
  props: {
    propsParams: {
      type: Object,
    },
  },
  setup(props) {
    const { t } = useI18n();
    const ParamValues = ref({
      requestId: "",
      StoreId: 0,
      status: "",
    });
    const routes = useRoute();
    const router = useRouter();

    let StoreId = routes.query.Id ?? 0;
    let status = routes.query.Type ?? "";
    ParamValues.value.StoreId = Number(StoreId);
    ParamValues.value.status = String(status);
    let session: any = localStorage.getItem("UsersData");

    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let dataValue = {
      StoreId: "",
      status: "",
    };
    watch(props, (newValue) => {
      debugger;
      Object.assign(dataValue, newValue.propsParams);
      ParamValues.value.StoreId = Number(props.propsParams);
      // alert('s')
      ItemShow();
    });
    onMounted(() => {
      IsShow();
    });
    const sidebardata = ref([]);
    let Id = ref();
    const headers = [
      {
        header: t("storetabdetails.grnretrundetails.Category"),
        field: "ItemCategory1",
      },
      {
        header: t("storetabdetails.grnretrundetails.Item#"),
        field: "ItemCode",
      },
      {
        header: t("storetabdetails.grnretrundetails.Itemname"),
        field: "Itemname1",
      },
      {
        header: t("storetabdetails.grnretrundetails.Quantity"),
        field: "ItemQuantity",
      },
      {
        header: t("storetabdetails.grnretrundetails.PackSize"),
        field: "PackSizename1",
      },

      {
        header: t("storetabdetails.grnretrundetails.UnitRate"),
        field: "unit rate",
      },
      // {
      //   header: "Total Value",
      //   field: "unit rate",
      // },
      {
        field: "action",
        header: "Action",
        slot: "action",
        frozencolumn: true,
        sortable: false,
      },
    ];
    // const route = useRoute();

    // const paramValue = computed(() => {
    //     return route.query.param as string;
    // });
    const globalFilterFields = ref(headers.map((col) => col.field));
    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      Name: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
      CreatedAt: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
      },
      Code: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
      length: {
        operator: FilterOperator.OR,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
    };
    let loading = ref(false);
    let items = ref([]);
    async function IsShow() {
      debugger;
      try {
        let response = await Service.GetStockOutTMTableList(
          12,
          177,
          0,
          HospitalId
        );
        // sidebardata.value = response["result"];
        const oldKey = "SupplierName";
        const newKey = "Name";
        const oldKey1 = "DocNo";
        const newKey1 = "Code";
        const oldKey2 = "StockOutTransId";
        const newKey2 = "Id";
        sidebardata.value = response["result"].map((item) => {
          const newItem = {
            ...item,
            [newKey]: item[oldKey],
            [newKey1]: item[oldKey1],
            [newKey2]: item[oldKey2],
          };
          delete newItem[oldKey];
          delete newItem[oldKey1];
          delete newItem[oldKey2];

          return newItem;
        });

        console.log(sidebardata.value);
      } catch (error) {
        console.log(error);
      }
    }
    let ItemList = ref([]);
    async function ItemShow() {
      // alert(Id.value)
      try {
        // console.log(Id)
        let response = await StockoutService.GetById(Id.value);
        ItemList.value = response["result"];

        console.log(items.value);
      } catch (error) {
        console.log(error);
      }
    }
    return {
      router,
      sidebardata,
      globalFilterFields,
      items,
      headers,
      filters,
      loading,
      Id,
      ItemShow,
      ItemList,
    };
  },
});
</script>
<style lang="scss">
.col-xl-2 {
  width: 19.666667%;
}

.col-xl-10 {
  width: 80.333333%;
}

.sidebar-static-header {
  padding: 15px 15px 20px 45px;
  font-weight: 600;
  border-bottom: 5px solid #f8f9fe;
  position: sticky;
  left: 0px;
  top: 0px;
  background-color: #f8f9fe;
  z-index: 1;
}

.other-tabs {
  height: 90vh;
  padding-left: 5px !important;
  overflow: auto;
}

.overall-bg {
  section {
    width: 100%;
    overflow: hidden;
  }
}

.leftsidebar {
  position: relative;
  padding-right: 0px !important;
}

.back-btn {
  background-color: #0148e2;
  border-radius: 50%;
  height: 35px;
  width: 35px;
  position: absolute;
  top: 20px;
  right: -12px;
  z-index: 1000;

  .back {
    width: 20px;
    position: absolute;
    top: -45px;
    left: 8px;
    // filter: invert(100%) sepia(2%) saturate(0%) hue-rotate(141deg) brightness(98%) contrast(108%);
  }
}

.count-shows {
  font-weight: 300;
  padding-bottom: 10px;
}

.Actionsbtn {
  background-color: #4a8fe9 !important;
  border: none !important;
  padding: 8px !important;
}

.overall-bg {
  background-color: #f8f9fe;
  padding: 0;
  height: auto;
}

.header-top {
  margin-top: 0px !important;
}

.steps .p-tabview-header {
  width: 20% !important;
}

.steps .p-tabview-header-action {
  justify-content: center !important;
}

.Tabheading {
  font-size: small;
}

.summarycard {
  font-size: small !important;
}

// .p-tabview .p-tabview-nav li .p-tabview-nav-link {
//     border: none !important;
// }

// .pi-check-circle {
//     color: green;
//     letter-spacing: 7px;
//     font-size: 200px;
// }

.sidebar-det-list {
  color: black !important;
}
</style>
